<template>
  <div>
    <b-card  title="Hoş Geldiniz! 🚀">
      <b-card-text>PMS dünyasının müthiş ötesi imkanlarından faydalanmak için modüller arasında gezinebilirsiniz.</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink,BImg } from 'bootstrap-vue'
import CustomerAccountDetailView  from './customer-account/CustomerAccountDetailView.vue'
import Notifications from '@/utilities/notifications'
import Auth from '@/utilities/auth'
export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    CustomerAccountDetailView
  },
  data(){
    return{
      isCustomer:false
    }
  },
  mounted(){
    this.getCustomer()
  },
  methods:{
    getCustomer(){
      this.isCustomer= Auth.isCustomer
    }
  }
}
</script>

<style>

</style>
